import {AdvancedFilter} from "@/poster-gallery/classes/advanced-filters/advanced-filter";

export class ColorFilter extends AdvancedFilter {
    static advancedFiltersArrayKey = 'color';

    updateFilterTypeButton(chosenFilterOption) {
        super.updateFilterTypeButton(chosenFilterOption);

        const filterTypeButtonContainer = this.getFilterTypeButtonContainer();
        filterTypeButtonContainer.find('.js-selected-color-filter').css('background', chosenFilterOption.attr('data-color-hex'));
    }
}